import { request } from '@umijs/max';

export async function fetchProductInfo(): Promise<API.PublicProductInfo> {
  return request<API.PublicProductInfo>('/api/product-info');
}
